export default __webpack_public_path__ + "static/media/oppressive_city_hidef.2daa1abc.PNG";